module.exports = __webpack_public_path__ + "static/media/S-agenda.08dd5819.svg";